<div class="page-content">
  <div class="page_header">
    <div class="page_header_text">
      <app-back-button></app-back-button>
    </div>
    <div class="page_header_actions" *ngIf="efetivo">
      <button class="btn-web-secondary" (click)="editarEfetivo()">
        <i class="fas fa-edit"></i> Editar
      </button>
    </div>
  </div>

  <div *ngIf="loadingEfetivo" class="skeleton-wrap">
    <p-skeleton height="200px"></p-skeleton>
  </div>

  <div *ngIf="!loadingEfetivo && efetivo" class="hero-card">
    <div class="hero-left">
      <div class="hero-avatar">
        <img *ngIf="efetivo.urlFotografia" [src]="fotoUrl" [alt]="efetivo.nome" class="hero-img" />
        <span *ngIf="!efetivo.urlFotografia" class="hero-initials">{{
          getInitials(efetivo.nome)
          }}</span>
        <div class="upload-overlay" (click)="fileInput.click()">
          <i class="pi pi-camera"></i>
          <input #fileInput type="file" hidden accept="image/png,image/jpeg,image/gif,image/webp"
            (change)="onFileSelected($event)" />
        </div>
      </div>
      <div class="hero-info">
        <h2>{{ efetivo.nome }}</h2>
        <p class="hero-funcao">
          {{ efetivo.nomeFuncao || "—" }} · {{ efetivo.nomeCategoria || "—" }}
        </p>
        <div class="hero-tags">
          <span class="estado-badge" [ngClass]="getEstadoBadgeClass(efetivo.estadoEfetivo)">
            <i [class]="getEstadoIcon(efetivo.estadoEfetivo)"></i>
            {{ getEstadoLabel(efetivo.estadoEfetivo) }}
          </span>
          <span class="badge-em-posto pulse" *ngIf="isTurnoIniciado">
            <i class="ri-map-pin-2-fill"></i> Em Serviço
          </span>
          <span class="badge-em-posto badge-pendente" *ngIf="escalaActiva?.posto && !isTurnoIniciado">
            <i class="ri-time-line"></i> Turno Não Iniciado
          </span>
        </div>
        <div class="hero-posto-pill" *ngIf="escalaActiva?.posto">
          <i class="fas fa-building"></i>
          <span>{{ escalaActiva.posto.nome }}</span>
          <span class="hero-turno-pill" *ngIf="escalaActiva.turnoContrato">{{
            escalaActiva.turnoContrato
            }}</span>
        </div>
      </div>
    </div>
    <div class="hero-stats">
      <div class="hero-stat">
        <span class="stat-value">{{ postosPassados.length }}</span>
        <span class="stat-label">Postos servidos</span>
      </div>
      <div class="hero-stat">
        <span class="stat-value">{{ ocorrencias.length }}</span>
        <span class="stat-label">Ocorrências</span>
      </div>
    </div>
  </div>

  <div *ngIf="!loadingEfetivo && efetivo">
    <p-tabs [(value)]="activeTabIndex">
      <p-tablist>
        <p-tab value="0">Informação</p-tab>
        <p-tab value="1">
          Histórico de postos
          <span class="tab-badge">{{ postosPassados.length }}</span>
        </p-tab>
        <p-tab value="2">
          Ocorrências
          <span class="tab-badge danger" *ngIf="ocorrencias.length">{{
            ocorrencias.length
            }}</span>
        </p-tab>
        <p-tab value="3">
          Documentos
          <span class="tab-badge" *ngIf="documentos.length">{{
            documentos.length
            }}</span>
        </p-tab>
      </p-tablist>

      <p-tabpanels>
        <p-tabpanel value="0">
          <div class="tab-section">
            <div style="display: flex; flex-wrap: wrap; gap: 20px; width: 100%">
              <div style="
                  flex: 2 1 500px;
                  display: flex;
                  flex-direction: column;
                  gap: 20px;
                ">
                <div class="posto-activo-card" *ngIf="escalaActiva?.posto">
                  <div class="pac-header">
                    <span class="pac-badge pulse" *ngIf="isTurnoIniciado"><i class="ri-map-pin-2-fill"></i> Em
                      Serviço</span>
                    <span class="pac-badge pac-badge-pendente" *ngIf="!isTurnoIniciado"><i class="ri-time-line"></i>
                      Turno Não Iniciado</span>
                    <button class="btn-link" (click)="verDetalhePosto(escalaActiva.posto.id)">
                      <i class="ri-external-link-line"></i> Ver Posto
                    </button>
                  </div>
                  <h3 class="pac-nome">{{ escalaActiva.posto.nome }}</h3>
                  <p class="pac-codigo">{{ escalaActiva.posto.codigo }}</p>
                  <div class="pac-meta">
                    <span class="pac-turno-pill" *ngIf="escalaActiva.turnoContrato">
                      <i class="fas fa-clock"></i> Turno Contrato:
                      {{ escalaActiva.turnoContrato }}
                    </span>
                    <span class="pac-desde" *ngIf="escalaActiva.dataInicioContrato">
                      Desde {{ formatDate(escalaActiva.dataInicioContrato) }}
                    </span>
                  </div>
                </div>

                <div class="sem-posto-card" *ngIf="!escalaActiva?.posto">
                  <i class="ri-map-pin-time-line"></i>
                  <div>
                    <p class="spc-title">Sem posto ativo</p>
                    <p class="spc-sub">
                      Este efetivo não tem escala ativa no momento
                    </p>
                  </div>
                </div>

                <div class="section-block escala-semana-card">
                  <div class="escala-semana-header">
                    <div class="escala-semana-titulo">
                      <i class="pi pi-calendar"></i>
                      <h3>Escala da semana</h3>
                    </div>
                    <div class="escala-semana-periodo">
                      <button type="button" class="escala-semana-nav" (click)="semanaAnterior()"
                        aria-label="Semana anterior">
                        <i class="pi pi-chevron-left"></i>
                      </button>
                      <span>{{ getResumoSemana() }}</span>
                      <button type="button" class="escala-semana-nav" (click)="semanaSeguinte()"
                        aria-label="Semana seguinte">
                        <i class="pi pi-chevron-right"></i>
                      </button>
                    </div>
                  </div>

                  <div class="escala-semana-loading" *ngIf="loadingEscalasSemana">
                    <p-skeleton *ngFor="let item of skeletonsSemana" height="112px" borderRadius="10px"></p-skeleton>
                  </div>

                  <ng-container *ngIf="!loadingEscalasSemana">
                    <div class="escala-semana-grid" *ngIf="diasSemana.length; else semSemana">
                      <div *ngFor="let dia of diasSemana" class="escala-semana-dia" [class.hoje]="dia.eHoje">
                        <div class="escala-semana-dia-topo">
                          <span class="escala-semana-dia-label">{{ dia.label }}</span>
                          <span class="escala-semana-dia-numero">{{ dia.numero }}</span>
                        </div>

                        <ng-container *ngIf="dia.entradas.length; else semTurno">
                          <div *ngFor="let entrada of dia.entradas" class="escala-semana-turno"
                            [class.continuacao]="entrada.tipo === 'continuacao'">
                            <span class="escala-semana-turno-nome">{{ entrada.nomeTurno }}</span>
                            <span class="escala-semana-turno-hora">{{ entrada.horarioCompleto }}</span>
                            <span *ngIf="entrada.termina" class="escala-semana-turno-fim">termina</span>
                          </div>
                        </ng-container>

                        <ng-template #semTurno>
                          <span class="escala-semana-sem-turno">Sem turno</span>
                        </ng-template>
                      </div>
                    </div>

                    <ng-template #semSemana>
                      <div class="escala-semana-vazia">
                        <i class="pi pi-calendar-times"></i>
                        <span>Sem turnos previstos esta semana</span>
                      </div>
                    </ng-template>
                  </ng-container>

                  <div class="escala-semana-legenda" *ngIf="!loadingEscalasSemana">
                    <span class="escala-semana-legenda-item">
                      <span class="escala-semana-legenda-marca previsto"></span>
                      Turno previsto
                    </span>
                    <span class="escala-semana-legenda-item">
                      <span class="escala-semana-legenda-marca continuacao"></span>
                      Continuação / fim de turno
                    </span>
                  </div>
                </div>

                <div class="section-block">
                  <p class="section-title">
                    <i class="pi pi-shield" style="margin-right: 6px"></i>
                    Equipamentos Atribuídos
                  </p>

                  <div *ngIf="
                      efetivo.equipamentosChecklist?.length;
                      else emptyEquip
                    " style="
                      display: grid;
                      grid-template-columns: repeat(
                        auto-fill,
                        minmax(220px, 1fr)
                      );
                      gap: 14px;
                    ">
                    <div *ngFor="let eq of efetivo.equipamentosChecklist" style="
                        border: 1px solid var(--sp-border);
                        border-radius: 8px;
                        padding: 14px;
                        background: rgba(255, 255, 255, 0.01);
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                      ">
                      <div style="display: flex; align-items: center; gap: 12px">
                        <div style="
                            width: 36px;
                            height: 36px;
                            border-radius: 6px;
                            background: rgba(30, 111, 255, 0.08);
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: var(--sp-primary);
                            flex-shrink: 0;
                          ">
                          <i [class]="
                              eq.icon ||
                              getEquipamentoIcon(eq.tipoEquipamentoNome) ||
                              'pi pi-shield'
                            " style="font-size: 16px"></i>
                        </div>
                        <div style="
                            display: flex;
                            flex-direction: column;
                            gap: 2px;
                            min-width: 0;
                          ">
                          <span style="
                              font-size: 0.85rem;
                              font-weight: 600;
                              color: var(--sp-text);
                              overflow: hidden;
                              text-overflow: ellipsis;
                              white-space: nowrap;
                            ">
                            {{ eq.equipamentoNome }}
                          </span>
                          <span style="font-size: 0.72rem; color: var(--sp-muted)">
                            {{ eq.tipoEquipamentoNome }}
                          </span>
                        </div>
                      </div>

                      <div style="
                          display: flex;
                          align-items: center;
                          justify-content: space-between;
                          font-size: 0.76rem;
                          border-top: 1px solid rgba(255, 255, 255, 0.03);
                          padding-top: 8px;
                        ">
                        <span style="color: var(--sp-muted)">Estado:</span>
                        <span class="estado-badge" [ngClass]="
                            eq.estadoEquipamento === 'Bom'
                              ? 'estado-ativo'
                              : 'estado-suspenso'
                          " style="font-size: 10px; padding: 2px 6px">
                          {{ eq.estadoEquipamento }}
                        </span>
                      </div>

                      <div *ngIf="eq.observacao" style="
                          font-size: 0.74rem;
                          color: var(--sp-muted);
                          background: rgba(0, 0, 0, 0.15);
                          padding: 6px 10px;
                          border-radius: 6px;
                          border-left: 3px solid var(--sp-primary);
                          word-break: break-word;
                        ">
                        <strong>Obs:</strong> {{ eq.observacao }}
                      </div>

                      <div style="
                          font-size: 0.7rem;
                          color: var(--sp-muted);
                          text-align: right;
                          margin-top: auto;
                        ">
                        Registo: {{ formatDate(eq.dataRegistro) }}
                      </div>
                    </div>
                  </div>

                  <ng-template #emptyEquip>
                    <div class="pac-sem-equip" style="margin: 0; padding: 20px 0">
                      <i class="pi pi-info-circle"></i>
                      <span>Sem equipamentos checklist registados</span>
                    </div>
                  </ng-template>
                </div>
              </div>

              <div style="
                  flex: 1 1 320px;
                  display: flex;
                  flex-direction: column;
                  gap: 20px;
                ">
                <div class="section-block">
                  <p class="section-title">
                    <i class="pi pi-user" style="margin-right: 6px"></i> Dados
                    Pessoais
                  </p>
                  <div style="display: flex; flex-direction: column; gap: 14px">
                    <div class="info-item">
                      <span class="info-label">Nome Completo</span>
                      <span class="info-value">{{ efetivo.nome }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Nº do BI</span>
                      <span class="info-value mono">{{ efetivo.numBI }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Data de Nascimento</span>
                      <span class="info-value">{{
                        formatDate(efetivo.dataNascimento)
                        }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Género</span>
                      <span class="info-value">{{
                        getGeneroLabel(efetivo.genero)
                        }}</span>
                    </div>
                  </div>
                </div>

                <div class="section-block">
                  <p class="section-title">
                    <i class="pi pi-briefcase" style="margin-right: 6px"></i>
                    Informações Profissionais
                  </p>
                  <div style="display: flex; flex-direction: column; gap: 14px">
                    <div class="info-item">
                      <span class="info-label">Função</span>
                      <span class="info-value">{{
                        efetivo.nomeFuncao || "—"
                        }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Categoria</span>
                      <span class="info-value">{{
                        efetivo.nomeCategoria || "—"
                        }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Data de Admissão</span>
                      <span class="info-value">{{
                        formatDate(efetivo.dataAdmissao)
                        }}</span>
                    </div>
                    <div class="info-item" *ngIf="efetivo.salarioBase">
                      <span class="info-label">Salário Base</span>
                      <span class="info-value">{{
                        efetivo.salarioBase
                        | currency: "AOA" : "symbol" : "1.0-0"
                        }}</span>
                    </div>
                    <div class="info-item" *ngIf="efetivo.mac || efetivo.Mac">
                      <span class="info-label">Endereço MAC</span>
                      <span class="info-value mono">{{
                        efetivo.mac || efetivo.Mac
                        }}</span>
                    </div>
                  </div>
                </div>

                <div class="section-block">
                  <p class="section-title">
                    <i class="pi pi-phone" style="margin-right: 6px"></i>
                    Contactos
                  </p>
                  <div style="display: flex; flex-direction: column; gap: 14px">
                    <div class="info-item">
                      <span class="info-label">Telefone</span>
                      <span class="info-value">{{ efetivo.numTelefone }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">E-mail</span>
                      <span class="info-value" style="word-break: break-all">{{
                        efetivo.email || "—"
                        }}</span>
                    </div>
                    <div class="info-item">
                      <span class="info-label">Morada</span>
                      <span class="info-value">{{
                        efetivo.modara || "—"
                        }}</span>
                    </div>
                  </div>
                </div>

                <div class="section-block contacto-emergencia-card">
                  <p class="section-title">
                    <i class="pi pi-phone"></i>
                    Contacto de emergência
                  </p>

                  <ng-container *ngIf="
                      obterContactoEmergencia(
                        efetivo.nomeContactoEmergencia,
                        efetivo.numTelContactoEmergencia
                      ) as contacto;
                      else semContactoEmergencia
                    ">
                    <div class="contacto-emergencia-conteudo">
                      <div class="contacto-emergencia-detalhes">
                        <span class="contacto-emergencia-nome">{{
                          contacto.nome
                          }}</span>
                        <span class="contacto-emergencia-meta">
                          {{ getParentescoLabel(
                          efetivo.efetivoGrauParentescoEnum ||
                          efetivo.parentescoContactoEmergencia
                          ) }}
                          · {{ contacto.telefone }}
                        </span>
                      </div>

                      <a class="contacto-emergencia-ligar"
                        [href]="'tel:' + telefoneParaLigacao(contacto.telefone)"
                        [attr.aria-label]="'Ligar para ' + contacto.nome">
                        <i class="pi pi-phone"></i>
                        Ligar
                      </a>
                    </div>
                  </ng-container>

                  <ng-template #semContactoEmergencia>
                    <div class="contacto-emergencia-vazio">
                      <i class="pi pi-info-circle"></i>
                      <span>Sem contacto de emergência registado</span>
                    </div>
                  </ng-template>
                </div>

                <div class="section-block" *ngIf="efetivo.banco || efetivo.iban">
                  <p class="section-title">
                    <i class="pi pi-credit-card" style="margin-right: 6px"></i>
                    Informações Bancárias
                  </p>
                  <div style="display: flex; flex-direction: column; gap: 14px">
                    <div class="info-item" *ngIf="efetivo.banco">
                      <span class="info-label">Banco</span>
                      <span class="info-value">{{ efetivo.banco }}</span>
                    </div>
                    <div class="info-item" *ngIf="efetivo.iban">
                      <span class="info-label">IBAN</span>
                      <span class="info-value mono">{{ efetivo.iban }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-tabpanel>

        <p-tabpanel value="1">
          <div class="tab-section history-posts">
            <div class="history-posts-heading">
              <h2>Histórico de postos</h2>
              <span>Do mais recente para o mais antigo</span>
            </div>

            <div class="history-summary">
              <article class="history-summary-card">
                <i class="ri-map-pin-line"></i>
                <strong>{{ postosPassados.length }}</strong>
                <span>Postos servidos</span>
              </article>
              <article class="history-summary-card">
                <i class="ri-time-line"></i>
                <strong>{{ getDuracaoPostoActual() }}</strong>
                <span>No posto actual</span>
              </article>
              <article class="history-summary-card">
                <i class="ri-calendar-check-line"></i>
                <strong>{{ getTotalTurnosCumpridos() ?? "—" }}</strong>
                <span>Turnos cumpridos (total)</span>
              </article>
            </div>

            <div *ngIf="loadingPostosPassados" class="history-posts-loading">
              <p-skeleton height="220px" *ngFor="let item of [1, 2]"></p-skeleton>
            </div>

            <app-empty-state *ngIf="!loadingPostosPassados && postosPassados.length === 0"
              icon="ri-map-pin-time-line" title="Sem histórico de postos"
              message="Este efectivo ainda não foi escalado para nenhum posto."
              actionLabel="Atribuir Posto" (action)="openAtribuirPostoDialog()" />

            <div class="history-timeline" *ngIf="!loadingPostosPassados && postosPassados.length > 0">
              <article class="history-entry" *ngFor="let posto of postosPassados"
                [class.is-current]="posto.actual">
                <div class="history-entry-marker" aria-hidden="true">
                  <span class="history-entry-dot"></span>
                  <span class="history-entry-line"></span>
                </div>

                <section class="history-post-card">
                  <header class="history-post-header">
                    <div class="history-post-title">
                      <h3>{{ posto.descricao }}</h3>
                      <span class="history-post-status" [class.current]="posto.actual">
                        {{ posto.actual ? "Actual" : "Terminado" }}
                      </span>
                    </div>
                    <p class="history-post-client">
                      <span *ngIf="posto.codigo">{{ posto.codigo }}<span *ngIf="posto.nomeCliente"> · </span></span>
                      <span *ngIf="posto.nomeCliente">{{ posto.nomeCliente }}</span>
                    </p>
                  </header>

                  <div class="history-post-details">
                    <div class="history-detail">
                      <span>Regime</span>
                      <strong>{{ posto.turno || "—" }}</strong>
                    </div>
                    <div class="history-detail">
                      <span>Início</span>
                      <strong>{{ posto.dataInicio ? formatDate(posto.dataInicio) : "—" }}</strong>
                    </div>
                    <div class="history-detail">
                      <span>Fim</span>
                      <strong>{{ posto.actual ? "Em curso" : (posto.dataTermino ? formatDate(posto.dataTermino) : "—") }}</strong>
                    </div>
                    <div class="history-detail">
                      <span>Duração</span>
                      <strong>{{ getDuracaoPosto(posto) }}</strong>
                    </div>
                  </div>

                  <div class="history-post-stats">
                    <div class="history-post-stat">
                      <strong>{{ posto.turnosCumpridos ?? "—" }}</strong>
                      <span>Turnos cumpridos</span>
                    </div>
                    <div class="history-post-stat">
                      <strong>{{ posto.faltas ?? "—" }}</strong>
                      <span>Faltas</span>
                    </div>
                    <div class="history-post-stat">
                      <strong>{{ !ocorrenciasDisponiveis ? "—" : getOcorrenciasPosto(posto) }}</strong>
                      <span>Ocorrências reportadas</span>
                    </div>
                  </div>

                  <p class="history-post-reason" *ngIf="!posto.actual && posto.motivoSaida">
                    <strong>Motivo da saída:</strong> {{ posto.motivoSaida }}
                  </p>

                  <a class="history-post-link" [routerLink]="['/admin/postos', posto.id]">
                    Ver posto <i class="ri-arrow-right-line"></i>
                  </a>
                </section>
              </article>
            </div>
          </div>
        </p-tabpanel>

        <p-tabpanel value="2">
          <div class="tab-section">
            <div class="tab-toolbar">
              <span class="tab-count">{{ ocorrencias.length }} ocorrência(s)</span>
            </div>

            <div *ngIf="loadingOcorrencias" class="skeleton-wrap">
              <p-skeleton height="52px" styleClass="mb-2" *ngFor="let i of [1, 2, 3]"></p-skeleton>
            </div>

            <div *ngIf="!loadingOcorrencias">
              <app-empty-state *ngIf="ocorrencias.length === 0" icon="ri-alarm-warning-line"
                title="Sem ocorrências registadas" message="Não existem ocorrências associadas a este efetivo." />

              <div class="ocorr-list" *ngIf="ocorrencias.length > 0">
                <div class="ocorr-card" *ngFor="let oc of ocorrencias">
                  <div class="ocorr-left">
                    <div class="ocorr-dot" [ngClass]="getCriticidadeClass(oc.criticidade)"></div>
                    <div class="ocorr-info">
                      <p class="ocorr-tipo">
                        {{ getTipoOcorrenciaLabel(oc.tipoOcorrencia) }}
                      </p>
                      <p class="ocorr-data">
                        <i class="ri-calendar-line"></i>
                        {{ formatDate(oc.dataOcorrencia) }}
                        <span *ngIf="oc.posto"> · {{ oc.posto?.nome }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="ocorr-right">
                    <span class="badge" [ngClass]="getCriticidadeClass(oc.criticidade)">
                      {{ getCriticidadeLabel(oc.criticidade) }}
                    </span>
                    <span class="badge" [class.badge-ativo]="oc.estado === 'FECHADO'"
                      [class.badge-pendente]="oc.estado !== 'FECHADO'">
                      {{ oc.estado || "—" }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-tabpanel>

        <p-tabpanel value="3">
          <div class="tab-section">
            <div class="tab-toolbar">
              <span class="tab-count">{{ documentos.length }} documento(s)</span>
              <button class="btn-primary sm" (click)="showUploadDialog = true">
                <i class="ri-upload-line"></i> Adicionar
              </button>
            </div>

            <div *ngIf="loadingDocumentos" class="skeleton-wrap">
              <p-skeleton height="52px" styleClass="mb-2" *ngFor="let i of [1, 2, 3]"></p-skeleton>
            </div>

            <div *ngIf="!loadingDocumentos">
              <app-empty-state *ngIf="documentos.length === 0" icon="ri-folder-open-line" title="Sem documentos"
                message="Nenhum documento foi anexado a este efetivo." actionLabel="Adicionar Documento"
                (action)="showUploadDialog = true" />

              <div class="equip-list" *ngIf="documentos.length > 0">
                <div class="equip-card" *ngFor="let doc of documentos">
                  <div class="equip-left">
                    <div class="equip-icon">
                      <i class="ri-file-pdf-line"></i>
                    </div>
                    <div class="equip-info">
                      <p class="equip-codigo">
                        {{ doc?.nomeAnexo || doc?.designacao || "Documento" }}
                      </p>
                      <p class="equip-tipo">{{ doc?.tipoAnexo || "—" }}</p>
                    </div>
                  </div>
                  <div class="equip-right">
                    <button type="button" class="btn-icon-sm" (click)="kebabMenu.toggle($event)" pTooltip="Opções"
                      tooltipPosition="left">
                      <i class="pi pi-ellipsis-v"></i>
                    </button>
                    <p-menu #kebabMenu [model]="getDocumentoMenuItems(doc)" [popup]="true" appendTo="body"></p-menu>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>

  <app-editar-efetivo
    [visible]="mostrarDrawerEditar"
    (visibleChange)="onEditarDrawerVisibleChange($event)"
    [efetivoId]="currentEfetivoId"
    (saved)="onEfetivoEditado()"
  />

  <p-drawer [(visible)]="showUploadDialog" position="right" [modal]="true" [style]="{ width: '460px' }"
    styleClass="efetivo-drawer-dark" [closable]="true">
    <ng-template pTemplate="header">
      <div class="dlg-header">
        <div class="dlg-header-icon"><i class="ri-file-upload-line"></i></div>
        <div class="dlg-header-title">Adicionar Documento</div>
      </div>
    </ng-template>

    <div class="dialog-form">
      <div class="form-group">
        <label>Tipo de Documento
          <span style="color: var(--sp-danger)">*</span></label>
        <p-select [options]="tiposDocumento" [(ngModel)]="tipoDocumento" optionLabel="designacao" optionValue="id"
          placeholder="Seleccionar tipo" styleClass="w-full" appendTo="body" />
      </div>
      <div class="form-group">
        <label>Designação <span style="color: var(--sp-danger)">*</span></label>
        <input type="text" pInputText [(ngModel)]="designacao" placeholder="Informe a designação" styleClass="w-full" />
      </div>
      <div class="form-group">
        <label>Ficheiro <span style="color: var(--sp-danger)">*</span></label>
        <div class="upload-zone" [class.has-file]="selectedDoc" (click)="docFileInput.click()"
          (dragover)="$event.preventDefault()" (drop)="onDocDrop($event)">
          <input #docFileInput type="file" accept=".pdf,.jpg,.jpeg,.png" (change)="onDocSelect($event)" hidden />
          <ng-container *ngIf="!selectedDoc">
            <i class="fas fa-cloud-upload-alt upload-zone__icon"></i>
            <span class="upload-zone__title">Arraste ou clique para seleccionar</span>
            <span class="upload-zone__hint">PDF, JPG ou PNG</span>
          </ng-container>
          <ng-container *ngIf="selectedDoc">
            <i class="fas fa-file-signature upload-zone__icon has-file-icon"></i>
            <span class="upload-zone__filename">{{ selectedDoc.name }}</span>
            <button type="button" class="upload-zone__clear" (click)="$event.stopPropagation(); selectedDoc = null">
              <i class="fas fa-times"></i> Remover
            </button>
          </ng-container>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="drawer-actions-right">
        <button type="button" class="btn-web-secondary" [disabled]="uploadLoading"
          (click)="showUploadDialog = false; selectedDoc = null">
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button type="button" class="btn-web-primary"
          [disabled]="!selectedDoc || !tipoDocumento || !designacao || uploadLoading" (click)="uploadDocumento()">
          <i *ngIf="uploadLoading" class="pi pi-spin pi-spinner"></i>
          <i *ngIf="!uploadLoading" class="ri-upload-line"></i>
          <span>{{ uploadLoading ? "A enviar..." : "Guardar" }}</span>
        </button>
      </div>
    </ng-template>
  </p-drawer>

  <p-drawer [(visible)]="showAtribuirPosto" position="right" styleClass="atribuir-drawer-dark efetivo-drawer-dark"
    [modal]="true" [closable]="true" [style]="{ width: 'min(90vw, 540px)' }" (onHide)="showAtribuirPosto = false">
    <div class="modal-header">
      <h3><i class="pi pi-user-plus"></i> Atribuir Posto ao Efetivo</h3>
      <button class="modal-close" (click)="showAtribuirPosto = false">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="modal-body">
      <div class="ae-subtitle">
        <span>Efetivo: <strong>{{ efetivo?.nome }}</strong></span>
      </div>

      <div class="ae-search-bar">
        <div class="search-input-wrap">
          <i class="pi pi-search search-icon"></i>
          <input type="text" class="search-input" placeholder="Pesquisar posto por nome, código ou local..."
            [(ngModel)]="searchPosto" (input)="filterPostos()" [ngModelOptions]="{ standalone: true }" />
        </div>
      </div>

      <div class="ae-list-wrapper" *ngIf="!selectedPosto">
        <p class="ae-list-hint">
          <i class="pi pi-info-circle"></i> Selecione o posto onde o efetivo
          será colocado
        </p>
        <div class="ae-efetivos-list">
          <div *ngFor="let posto of filteredPostosList" class="ae-efetivo-item"
            [class.selected]="posto.id === selectedPosto?.id" (click)="selectPosto(posto)">
            <div class="ae-ef-avatar">
              {{ posto.nome.charAt(0) }}{{ posto.nome.charAt(1) }}
            </div>
            <div class="ae-ef-info">
              <strong>{{ posto.nome }}</strong>
              <span>{{ posto.codigo }} · {{ posto.nomeTipoPosto }}</span>
              <span class="ae-ef-posto">{{ posto.endereco | slice: 0 : 40 }}...</span>
            </div>
            <div class="ae-ef-action">
              <i class="pi pi-chevron-right" style="color: var(--text-muted)"></i>
            </div>
          </div>
          <div class="ae-empty" *ngIf="filteredPostosList?.length === 0">
            <i class="pi pi-inbox"></i>
            <span>Nenhum posto encontrado</span>
          </div>
        </div>
      </div>

      <ng-container *ngIf="selectedPosto">
        <div class="ae-selected-section">
          <div class="ae-selected-info">
            <p-avatar [label]="selectedPosto?.nome?.split(' ').map(w => w.charAt(0)).slice(0, 2).join('').toUpperCase()"
              class="mr-2" size="large" shape="circle" [style]="{ 'background-color': '#22c55e', color: '#fff' }" />
            <div>
              <strong>{{ selectedPosto.nome }}</strong>
              <span>{{ selectedPosto.codigo }} ·
                {{ selectedPosto.nomeTipoPosto }}</span>
              <span style="font-size: 10px; color: var(--text-muted)">{{
                selectedPosto.endereco
                }}</span>
            </div>
            <button class="ae-deselect-btn" (click)="
                selectedPosto = null; atribuirForm.get('idPosto')?.reset()
              ">
              <i class="pi pi-times"></i> Trocar
            </button>
          </div>
        </div>

        <form [formGroup]="atribuirForm">
          <div class="form-section" style="margin-top: 16px">
            <h4 class="form-section-title">
              <i class="pi pi-clock"></i> Turno e Período
            </h4>
            <div class="form-grid-2">
              <div class="form-group full">
                <label>Turno <span class="required">*</span></label>
                <div class="shift-selector">
                  <button type="button" class="shift-opt" [class.active]="atribuirForm.get('turnoId')?.value === 1"
                    (click)="atribuirForm.get('turnoId')?.setValue(1)">
                    24/24
                  </button>
                  <button type="button" class="shift-opt" [class.active]="atribuirForm.get('turnoId')?.value === 2"
                    (click)="atribuirForm.get('turnoId')?.setValue(2)">
                    24/48
                  </button>
                </div>
              </div>
              <div class="form-group">
                <label>Data de Início <span class="required">*</span></label>
                <p-datepicker formControlName="dataInicio" dateFormat="dd/mm/yy" [showIcon]="true"
                  styleClass="form-input" appendTo="body" [autoZIndex]="true" [baseZIndex]="1000010"
                  panelStyleClass="drawer-datepicker-panel" />
              </div>
              <div class="form-group">
                <label>Data de Fim <span class="required">*</span></label>
                <p-datepicker formControlName="dataTermino" dateFormat="dd/mm/yy" [showIcon]="true"
                  styleClass="form-input" appendTo="body" [autoZIndex]="true" [baseZIndex]="1000010"
                  panelStyleClass="drawer-datepicker-panel" />
              </div>
            </div>
          </div>

          <div class="form-section">
            <h4 class="form-section-title">
              <i class="pi pi-pencil"></i> Observações
            </h4>
            <div class="form-group full">
              <textarea formControlName="observacoes" class="form-input" rows="3"
                placeholder="Notas adicionais sobre esta atribuição..."></textarea>
            </div>
          </div>

          <div class="ae-confirm-notice">
            <i class="pi pi-shield"></i>
            <span>A atribuição ficará registada no historial do efetivo e do
              posto.</span>
          </div>
        </form>
      </ng-container>
    </div>

    <div class="modal-footer">
      <button class="btn-web-secondary" (click)="showAtribuirPosto = false">
        Cancelar
      </button>
      <button class="btn-web-primary" (click)="confirmarAtribuicao()"
        [disabled]="!selectedPosto || atribuirForm.invalid || loadingAtribuir">
        <i class="pi pi-user-check"></i>
        {{ loadingAtribuir ? "A atribuir..." : "Confirmar Atribuição" }}
      </button>
    </div>
  </p-drawer>
</div>